import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const IntercollegesportsCompetition = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg40.jpg" },
  { img: "/assets/img/SOL/event/event1_mg41.jpg" },
  { img: "/assets/img/SOL/event/event1_mg42.jpg" },  
  
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="MVN University Students Excel at Inter-College Sports Competition" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
            <p>   Organized by: Rawal Institutions, Faridabad</p>
           <p>Date of Event: 26th April 2025  </p>
            <p> Participating Institution: MVN University, Palwal </p>

             <p> Event Highlights: </p>
           
           <ul>
              <li> 	Tanuj Chechi demonstrated exceptional strategic skills and concentration in the Chess Tournament, securing the First Prize and bringing laurels to MVN University.

</li>
              <li> 	 	In the thrilling Arm Wrestling Competition, Naman showcased outstanding strength and technique, winning the First Prize.

</li>
              <li> Arjun fought valiantly and secured the Second Prize in Arm Wrestling, adding further pride to the university’s achievements.

</li>
             
           </ul>

           <p>The event witnessed enthusiastic participation, and the victories by MVN University students reflected their hard work, determination, and competitive spirit.</p>
      
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default IntercollegesportsCompetition;
